import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => CheckBoxSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-shared-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR
    ]
})

export class CheckBoxSharedComponent implements ControlValueAccessor {
    isTicked = false;
    @Input() value;
    @Input() checkboxStyle: 'secondary' | 'button';
    @Input() size: 'small';

    constructor(private ref: ChangeDetectorRef) {}

    onChange: any = () => {};
    onTouched: any = () => {};

    update(): void {
        this.isTicked = !this.isTicked;
        this.onChange(this.isTicked);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value): void {
        if (!value) {
            this.isTicked = false;
            this.value = false;
        }

        if (value) {
            this.isTicked = true;
            this.value = value;
        }

        this.ref.markForCheck();
    }
}
